import { z } from 'zod';

const DEFAULT_MESSAGE = 'Obrigatório'

export const formSchema = z.object({
  name: z.string({ message: DEFAULT_MESSAGE }).min(1, { message: DEFAULT_MESSAGE }),
  carrier_id: z.string({ message: DEFAULT_MESSAGE }),
  general_company_id: z.string({ message: DEFAULT_MESSAGE }),
  backward_trip: z.string({ message: DEFAULT_MESSAGE }),
});

export type FormSchema = z.infer<typeof formSchema>;

